import { render, staticRenderFns } from "./holiday-type.vue?vue&type=template&id=b8c8ceee"
import script from "./holiday-type.vue?vue&type=script&lang=js"
export * from "./holiday-type.vue?vue&type=script&lang=js"
import style0 from "./holiday-type.vue?vue&type=style&index=0&id=b8c8ceee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports